import script from "./BuyProviders.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyProviders.vue?vue&type=script&lang=ts&setup=true"

import "./BuyProviders.vue?vue&type=style&index=0&id=5b9b1096&lang=scss&scoped=true"
import "./BuyProviders.vue?vue&type=style&index=1&id=5b9b1096&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9b1096"]])

export default __exports__